import { useLingui } from "@lingui/react";
import { ApiDatafanProject, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

import { useContextApp } from "@/screens/app/context/app";

const KEY = "datafan.project";

type Response = Await<ReturnType<typeof ApiDatafanProject.list>>;
type ResponseSelect = Response["results"][number] | undefined;

export const useQueryDatafanProject = (
  options?: Omit<
    UseQueryOptions<Response, FailureApi, ResponseSelect>,
    "queryKey" | "queryFn" | "select"
  >,
) => {
  const { i18n } = useLingui();
  const {
    state: { organizationId, me },
  } = useContextApp();
  const lang = i18n.locale === "ru" ? "ru" : "en";

  return useQuery<Response, FailureApi, ResponseSelect>(
    [KEY, organizationId],
    () =>
      ApiDatafanProject.list({
        lang,
        special_external_id: organizationId ? organizationId * -1 : me.id,
      }),
    {
      ...options,
      select: (data) =>
        data.results.find(
          (project) => project.special_subowner === "smmplanner",
        ),
    },
  );
};

useQueryDatafanProject.KEY = KEY;
